
import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo: {
    titleTemplate: '%s - Minesrv Admin'
  },
})
export default class App extends Vue {}
